import { render, staticRenderFns } from "./GameRecordAllView.vue?vue&type=template&id=9d9ef6f2&scoped=true"
import script from "./GameRecordAllView.vue?vue&type=script&lang=js"
export * from "./GameRecordAllView.vue?vue&type=script&lang=js"
import style0 from "./GameRecordAllView.vue?vue&type=style&index=0&id=9d9ef6f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9ef6f2",
  null
  
)

export default component.exports